const urlEnums = {
  rc: {
    baseUrl: 'https://apirc.kiscloud.net'
  },
  rc3: {
    baseUrl: 'https://apirc3.kiscloud.net'
  },
  prod: {
    baseUrl: 'https://api.kiscloud.net'
  }
}

const baserUrl = urlEnums[process.env.NODE_BUILD]
export default baserUrl
